export default "/images/vendor/flag-icon-css/flags/1x1/tg.svg?a54fe773a9a6f8f7ae6054c89fb0f33c";